import { createSelector } from '@reduxjs/toolkit'

import { getConfig } from '../root.selectors'

export const getBackendUrl = (state) => getConfig(state).backendUrl
export const getMaxAllowedTimeDifferenceWithServer = (state) => getConfig(state).maxAllowedTimeDifferenceWithServer

export const getRequiredFields = (state) => getConfig(state).requiredFields
export const getRequiredFieldsByKey = (state, key) => getRequiredFields(state)[key]

export const getHypothecAreaCheck = (state) => getConfig(state).shouldCheckHypothecAreasSum

export const getEnabledFullscreenTabs = createSelector(getConfig, (config) => config.enabledFullscreenTabs || [])
